import React from "react";
import "./Shimmer.scss";

interface ShimmerProps {
  rows?: number;
}

export const Shimmer: React.FC<ShimmerProps> = ({ rows = 5 }) => {
  return (
    <div className="shimmer-container">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="shimmer-card">
          <div className="shimmer-line shimmer-line-wide" />
          <div className="shimmer-line shimmer-line-medium" />
          <div className="shimmer-line shimmer-line-narrow" />
        </div>
      ))}
    </div>
  );
};
